export var EDataSource;
(function (EDataSource) {
    EDataSource["LOB"] = "LOB";
    EDataSource["SUBLOB"] = "SUBLOB";
    EDataSource["ZONE"] = "ZONE";
    EDataSource["REGION"] = "REGION";
    EDataSource["BRANCH"] = "BRANCH";
    EDataSource["ROLE"] = "ROLE";
    EDataSource["TYPE"] = "TYPE";
    EDataSource["TEAMTYPE"] = "TEAMTYPE";
    EDataSource["RM"] = "RM";
    EDataSource["FY"] = "FY";
    EDataSource["QUARTER"] = "QUARTER";
    EDataSource["MONTH"] = "MONTH";
    EDataSource["PRODUCT"] = "PRODUCT";
    EDataSource["SUBPRODUCT"] = "SUBPRODUCT";
    EDataSource["TIER"] = "TIER";
    EDataSource["PARTNER"] = "partner";
    EDataSource["Participant"] = "Participant";
})(EDataSource || (EDataSource = {}));
export var EnumSalesFilter;
(function (EnumSalesFilter) {
    EnumSalesFilter["displayId"] = "displayId";
    EnumSalesFilter["lobId"] = "lobId";
    EnumSalesFilter["lobIdLst"] = "lobIdLst";
    EnumSalesFilter["sublobId"] = "sublobId";
    EnumSalesFilter["sublobIdLst"] = "sublobIdLst";
    EnumSalesFilter["zoneId"] = "zoneId";
    EnumSalesFilter["zoneIdLst"] = "zoneIdLst";
    EnumSalesFilter["regionId"] = "regionId";
    EnumSalesFilter["regionIdLst"] = "regionIdLst";
    EnumSalesFilter["branchId"] = "branchId";
    EnumSalesFilter["branchIdLst"] = "branchIdLst";
    EnumSalesFilter["rmId"] = "rmId";
    EnumSalesFilter["rmIdLst"] = "rmIdLst";
    EnumSalesFilter["clientTier"] = "clientTier";
    EnumSalesFilter["clientTierLst"] = "clientTierLst";
    EnumSalesFilter["type"] = "type";
    EnumSalesFilter["fromDate"] = "fromDate";
    EnumSalesFilter["toDate"] = "toDate";
    EnumSalesFilter["clientName"] = "clientName";
    EnumSalesFilter["pan"] = "pan";
    EnumSalesFilter["email"] = "email";
    EnumSalesFilter["mobileNo"] = "mobileNo";
    EnumSalesFilter["leadId"] = "leadId";
    EnumSalesFilter["clientSeachKey"] = "clientSeachKey";
    EnumSalesFilter["custType"] = "custType";
    EnumSalesFilter["custTypeLst"] = "custTypeLst";
    EnumSalesFilter["mode"] = "mode";
    EnumSalesFilter["modeLst"] = "modeLst";
    EnumSalesFilter["scheme"] = "scheme";
    EnumSalesFilter["schemeLst"] = "schemeLst";
    EnumSalesFilter["status"] = "status";
    EnumSalesFilter["statusLst"] = "statusLst";
    EnumSalesFilter["interactionStatus"] = "interactionStatus";
    EnumSalesFilter["interactionStatusLst"] = "interactionStatusLst";
    EnumSalesFilter["interactionSubStatus"] = "interactionSubStatus";
    EnumSalesFilter["interactionSubStatusLst"] = "interactionSubStatusLst";
    EnumSalesFilter["partnerId"] = "partnerId";
    EnumSalesFilter["partnerIdLst"] = "partnerIdLst";
    EnumSalesFilter["productId"] = "productId";
    EnumSalesFilter["nrproductId"] = "nrproductId";
    EnumSalesFilter["productIdLst"] = "productIdLst";
    EnumSalesFilter["subproductId"] = "subproductId";
    EnumSalesFilter["subproductIdLst"] = "subproductIdLst";
    EnumSalesFilter["role"] = "role";
    EnumSalesFilter["roleLst"] = "roleLst";
    EnumSalesFilter["bucketId"] = "bucketId";
    EnumSalesFilter["bucketIdLst"] = "bucketIdLst";
    EnumSalesFilter["teamType"] = "teamType";
    EnumSalesFilter["teamTypeLst"] = "teamTypeLst";
    EnumSalesFilter["expiryId"] = "expiryId";
    EnumSalesFilter["expiryIdLst"] = "expiryIdLst";
    EnumSalesFilter["isCommented"] = "isCommented";
    EnumSalesFilter["followupCount"] = "followupCount";
    EnumSalesFilter["isUncalledLeads"] = "isUncalledLeads";
    EnumSalesFilter["participants"] = "Participant";
    EnumSalesFilter["participantsLst"] = "participantsLst";
    EnumSalesFilter["categoryId"] = "categoryId";
    EnumSalesFilter["categoryIdLst"] = "categoryIdLst";
    EnumSalesFilter["sourceId"] = "sourceId";
    EnumSalesFilter["sourceIdLst"] = "sourceIdLst";
    EnumSalesFilter["subSourceId"] = "subSourceId";
    EnumSalesFilter["subSourceIdLst"] = "subSourceIdLst";
    EnumSalesFilter["leadType"] = "leadType";
    EnumSalesFilter["isfollowupAging"] = "isfollowupAging";
})(EnumSalesFilter || (EnumSalesFilter = {}));
